import {
  Radio,
  SelectItem,
  RadioGroup,
  TextArea,
  TextField,
  NumberField,
  Select,
} from "@certn/cascadia-react";
import { components } from "@certn/api/generated-schemas/applicant-portal";
import { Trans } from "react-i18next";
import { FormikProps } from "formik";
import { CustomQuestionnaireFormType } from "./types";
import isNil from "lodash/isNil";

type Props = components["schemas"]["CustomQuestionnaireTemplateInputClaim"] & {
  onChange: (value: string | number | boolean | null) => void;
  errors?: string;
  value?: string;
  handleBlur: FormikProps<CustomQuestionnaireFormType[]>["handleBlur"];
};

export function CustomQuestionnaireField({
  onChange,
  is_optional,
  handleBlur,
  ...props
}: Props) {
  const commonFieldProps = {
    ...props,
    isRequired: !is_optional,
    testID: `custom-questionnaire-field-${props.name}`,
    onChange,
    onBlur: handleBlur,
    isInvalid: !!props.errors,
  };

  if (props.type === "str") {
    const constraints = props.constraints ? props.constraints[0] : undefined;
    const hasSelectableOptions = !!constraints;

    if (hasSelectableOptions) {
      const selectableOptions = constraints.selectable_options;
      const widget = props.display_options?.widget ?? "dropdown";

      if (widget === "radio") {
        return (
          <RadioGroup {...commonFieldProps} orientation="horizontal">
            {selectableOptions.map((option) => (
              <Radio
                key={option.value}
                value={option.value}
                testID={`custom-questionnaire-field-${props.name}-${option.value}-radio-button`}
              >
                {option.label}
              </Radio>
            ))}
          </RadioGroup>
        );
      }

      return (
        <Select
          {...commonFieldProps}
          selectedKey={props.value}
          onSelectionChange={onChange}
        >
          {selectableOptions.map((option) => (
            <SelectItem key={option.value} id={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </Select>
      );
    }

    const multiline = props.display_options?.multiline ?? false;

    return multiline ? (
      <TextArea {...commonFieldProps} />
    ) : (
      <TextField {...commonFieldProps} />
    );
  }

  if (props.type === "int" || props.type === "float") {
    return (
      <NumberField
        {...commonFieldProps}
        step={props.type === "float" ? 0.1 : 1}
        defaultValue={0}
        value={isNil(props.value) ? undefined : Number(props.value)}
        errorMessage={props.errors}
      />
    );
  }

  if (props.type === "bool") {
    return (
      <RadioGroup {...commonFieldProps} orientation="horizontal">
        <Radio
          value="true"
          testID={`custom-questionnaire-field-${props.name}-true-radio-button`}
        >
          <Trans>Yes</Trans>
        </Radio>
        <Radio
          value="false"
          testID={`custom-questionnaire-field-${props.name}-false-radio-button`}
        >
          <Trans>No</Trans>
        </Radio>
      </RadioGroup>
    );
  }
  if (props.type === "file_upload") {
    console.warn("File upload field type not implemented yet");
    // file_upload type goes here
    return <></>;
  }
  return <></>;
}
